<template>
    <div class="bg">
        <el-header style="height: 4%; display: flex;justify-content: space-between;">
            <div style="display: flex;gap:10px;">
                <img src="@/assets/favicon.png" alt="">
                <div class="header-text-left">凌丰供应商系统</div>
                <div class="pe-header-text">加工单（明细）</div>
            </div>
            <div style="width: 320px;">
                <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
            </div>
        </el-header>
        <div class="proc_nav">
            <div class="nav_left">
                <el-descriptions title="" :column="3" border>
                    <el-descriptions-item label="加工单编号" :contentStyle="{ width: '200px', }" :labelStyle="labelStyle">
                        <div>{{ headObj.formCode }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="加工商" contentStyle='width :200px' :labelStyle="labelStyle">
                        <div>{{ headObj.supplier?.supplierName }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="合同号" contentStyle='width :200px' :labelStyle="labelStyle">
                        <div>{{ headObj.project?.trackNumber }}</div>
                    </el-descriptions-item>
                    <!-- <el-descriptions-item label="状态" contentStyle='width :200px' :labelStyle="labelStyle">
                    </el-descriptions-item> -->
                    <el-descriptions-item label="建单日期" contentStyle='width :200px' :labelStyle="labelStyle">
                        <div>{{ formatDateYear(headObj.createTime) }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="需用日期" contentStyle='width :200px' :labelStyle="labelStyle">
                        <div>{{ formatDateYear(headObj.deadline) }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="项目名称" contentStyle='width :200px' :labelStyle="labelStyle">
                        <div>{{ headObj.projectName }}</div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="nav_right">
                <div style="display: flex;">
                    <el-button size="small" type="primary" @click="search">刷新</el-button>
                    <el-button size="small" type="success" @click="per_gen">申请发货</el-button>
                    <el-button size="small" type="warning" @click="clear_selection">清空勾选</el-button>
                </div>
                <div>
                    <el-checkbox v-model="search_obj.isAudit" @change="search">只显示未发货/部分发货</el-checkbox>
                </div>
            </div>
        </div>
        <div class="table-body">
            <el-table ref="procDetailTable" :data="table_data" border stripe height="100%"
                :header-row-style="{ height: '0' }" :header-cell-style="{
                    background: '#78b5ec',
                    color: '#000',
                    padding: '0',
                    fontWeight: '400',
                    textAlign: 'center',
                }" :row-style="{ height: '35px' }" :cell-style="{ padding: '2px 0' }" :row-class-name="rowClassName"
                row-key="id" v-loading="table_loading" @row-click="clickRow">
                <el-table-column type="selection" width="40" :reserve-selection="true" align="center"></el-table-column>
                <el-table-column label="图号" prop="mapCode" width="120" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column label="组件名称" prop="headMaterial" width="200" align="left" show-overflow-tooltip
                    sortable></el-table-column>
                <el-table-column label="零件号" prop="materialVo.materialCode" width="200" align="left"
                    show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="零件名称" prop="materialVo.materialName" width="200" align="left"
                    show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="备注" prop="remark" width="180" align="left" show-overflow-tooltip />
                <el-table-column label="单价" prop="unitPrice" width="100" align="left" sortable></el-table-column>
                <el-table-column label="金额" prop="totalPrice" width="100" align="left" sortable></el-table-column>
                <el-table-column label="数量" prop="qty" width="90" align="center" sortable></el-table-column>
                <el-table-column label="已申请" prop="sentQty" width="90" align="center" sortable>
                    <template slot-scope="ss">
                        {{ ss.row.sentQty ? ss.row.sentQty : '' }}
                    </template>
                </el-table-column>
                <el-table-column label="已发货" prop="approvedQty" width="90" align="center" sortable>
                    <template slot-scope="ss">
                        {{ ss.row.approvedQty ? ss.row.approvedQty : '' }}
                    </template>
                </el-table-column>
                <el-table-column label="已签收" prop="arrivedQty" width="90" align="center" sortable>
                    <template slot-scope="ss">
                        {{ ss.row.arrivedQty ? ss.row.arrivedQty : '' }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-footer">
            <el-pagination background layout="sizes, prev, pager, next, total" :total="total"
                @size-change="handleSizeChange" @current-change="change_data" :current-page="search_obj.currentPage"
                :page-size="search_obj.pageSize" :page-sizes="[10, 30, 50, 100, 200, 300, 400, 500]">
            </el-pagination>
        </div>
        <el-footer class="page_footer">© 2024 LINKFAIRTECH 版权所有</el-footer>

        <!-- 发货预览 -->
        <el-dialog title="申请发货预览" :visible.sync="gen_visiable" fullscreen>
            <div class="gen_data">
                <el-table :data="genData" height="100%" :header-row-style="{ height: '0' }" :header-cell-style="{
                    background: '#78b5ec',
                    color: '#000',
                    padding: '0',
                    fontWeight: '400',
                    textAlign: 'center',
                }" :row-style="{ height: '35px' }" :cell-style="{ padding: '2px 0' }" border stripe show-summary>
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="{ $index }">
                            <span>{{ $index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="图号" prop="mapCode" width="120" align="center"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column label="组件名称" prop="headMaterial" width="200" align="left" show-overflow-tooltip
                        sortable></el-table-column>
                    <el-table-column label="零件号" prop="materialVo.materialCode" width="200" align="left"
                        show-overflow-tooltip sortable></el-table-column>
                    <el-table-column label="零件名称" prop="materialVo.materialName" width="200" align="left"
                        show-overflow-tooltip sortable></el-table-column>
                    <el-table-column label="备注" prop="remark" width="100" align="left" show-overflow-tooltip />
                    <el-table-column label="单价" prop="unitPrice" width="100" align="left" sortable></el-table-column>
                    <el-table-column label="金额" prop="gen_totalprice" width="100" align="left"
                       
                        sortable></el-table-column>
                    <el-table-column label="数量" prop="qty" width="100" align="left" sortable></el-table-column>
                    <el-table-column label="已申请" prop="sentQty" width="100" align="left" sortable>
                        <template slot-scope="ss">
                            <span>{{ ss.row.sentQty ? ss.row.sentQty : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="已发货" prop="approvedQty" width="90" align="left" sortable>
                        <template slot-scope="ss">
                            <span>{{ ss.row.approvedQty ? ss.row.approvedQty : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="新增发货" prop="gen_num" width="150" align="center" sortable>
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.gen_num" :min="0"
                                :max="scope.row.qty - scope.row.sentQty" style="width:100%;" size="mini"
                                @change="count_totalprice(scope.row)">
                            </el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="60">
                        <template slot-scope="scope"><el-button type="danger" plain circle size="mini"
                                icon="el-icon-close" @click="item_close(scope.row)"></el-button></template>
                        <template slot-scope="scope"><el-button type="danger" plain circle size="mini"
                                icon="el-icon-close" @click="item_close(scope.row)"></el-button></template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="gen_visiable = false" size="small">取 消</el-button>
                <el-button type="primary" @click="fill_gennum" size="small">填充数量</el-button>
                <el-button type="success" @click="gen_send" size="small">申请发货</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import { formatDateYear } from '@/utils/func';
import { getOutSourceItemApi, genProcSendApi, urgeApi } from '@/Api/procApi'
export default {
    name: 'proc_detail',
    components: {
    },
    data() {
        return {
            timer: '',
            homeDate: '',
            headObj: '',
            userNme: sessionStorage.getItem('userName'),
            labelStyle: { width: '70px', textAlign: 'center', color: '#4d4d4d', backgroundColor: '#fff' },
            search_obj: {
                isAudit: true,
                pageSize: 30,
                currentPage: 1,
            },
            total: 30,
            header: {
                headers: { token: sessionStorage.getItem('token') }
            },
            table_data: [],
            table_loading: false,
            genData: [],
            useDate: '',
            loading2: false,
            project_options: [],
            contract_options: [],
            material_options: [],
            supplier_options: [],
            gen_visiable: false,
            addname_visiable: false,
            status_list: ['未发货', '部分发货', '在途', '部分签收', '签收完成'],
            select_alias: '',
            roleName: sessionStorage.getItem('roleName'),
            flag: false,

            statusList: [
                { id: 1, name: '保存', color: 'blue' },
                { id: 2, name: '提交', color: '#ef7b15' },
                { id: 4, name: '审核', color: '#12CAD6' },
                { id: 8, name: '签收', color: 'green' },
                { id: -4, name: '不通过', color: 'red' },
            ],
        }
    },
    computed: {

    },
    methods: {
        formatDateYear,
        //显示时间
        showTime() {
            this.timer = setInterval(() => {
                this.homeDate = this.$getTime()
            }, 1000);
        },
        get_data() {
            getOutSourceItemApi(this.search_obj, this).then(res => {
                this.table_data = res.records
                this.total = res.total
                this.$nextTick(() => {
                    this.$refs.procDetailTable.doLayout()
                })
            }).catch(() => { })
        },
        rowClassName({ row }) {
            const boll = this.$refs.procDetailTable.selection.some(item => item.id == row.id);
            if (boll) return 'selected-row'
        },
        //页码发生变化时
        change_data(e) {
            this.search_obj.currentPage = e
            this.get_data()
        },
        //修改每页大小
        handleSizeChange(e) {
            this.search_obj.pageSize = e
            this.search_obj.currentPage = 1
            this.get_data()
        },
        //状态颜色
        status_color(row) {
            if (row.statusName == '未发货') return 'info'
            else if (row.statusName == '部分发货') return 'warning'
            else if (row.statusName == '在途' || row.statusName == '部分签收') return ''
            else if (row.statusName == '签收完成') return 'success'
        },
        goto_sendPage() {
            const { href } = this.$router.resolve({
                path: '/sendPage',
            })
            window.open(href, '_blank')
        },
        clear_selection() {
            this.$confirm('清空所有勾选吗？', '提示', {
                confirmButtonText: '清空',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.procDetailTable.clearSelection();
            }).catch(() => {
            });
        },
        usedate_change() {
            if (this.useDate) {
                this.search_obj.startUseDate = this.useDate[0]
                this.search_obj.endUseDate = this.useDate[1]
            } else {
                this.search_obj.startUseDate = ''
                this.search_obj.endUseDate = ''
            }
        },
        per_gen() {
            if (this.$refs.procDetailTable.selection.length == 0) {
                this.$alert('请先勾选选项', '警告', { type: 'error' });
                return
            }
            // for (let item of this.$refs.procDetailTable.selection) {
            //     if (item.statusName != '未发货' && item.statusName != '部分发货') {
            //         this.$message({ type: 'warning', message: '请勾选未发货或部分发货的选项' })
            //         return
            //     }
            // }
            this.genData = structuredClone(this.$refs.procDetailTable.selection).map(item => {
                return {
                    ...item,
                    gen_totalprice: 0,
                    gen_num: 0
                }
            })
            this.gen_visiable = true
        },
        select_function(row) {
            if (row.statusName != '未发货' && row.statusName != '部分发货') return false
            return true
        },
        count_totalprice(row) {
            row.gen_totalprice = (row.unitPrice * row.gen_num).toFixed(2)
        },
        // 预览页剔除项
        item_close(row) {
            let findRes = this.$refs.procDetailTable.selection.find(item => item.id == row.id)
            if (findRes) {
                this.genData = this.genData.filter(item => item.id != row.id)
                this.$refs.procDetailTable.toggleRowSelection(findRes);
            }
        },
        fill_gennum() {
            // this.multipleSelection.forEach(item => {
            //     item.gen_num = item.buyNumber - item.outputNumber
            //     item.gen_totalprice = (item.price * item.gen_num).toFixed(2)
            // })
            this.genData = this.genData.map(item => {
                return {
                    ...item,
                    gen_num: item.qty - item.sentQty,
                    gen_totalprice: (item.unitPrice * (item.qty - item.sentQty)).toFixed(2)
                }
            })
        },

        // 生成送货单
        gen_send() {
            if (this.genData.length == 0) {
                this.$alert('请先勾选单据项', '警告', { type: 'error' })
                return
            }
            if (this.genData.some(item => item.gen_num == 0)) {
                this.$alert('有数据项发货数量为0', '操作异常', { type: 'error' })
                return
            }
            this.$confirm('确定生成送货单？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                let submitData = this.genData.map(item => {
                    return {
                        procId: item.id,
                        qty: item.gen_num
                    }
                })
                genProcSendApi(submitData, this).then(res => {
                    urgeApi({ formCode: res }, this).then(() => {
                        this.$message({ type: 'success', message: '成功发送消息通知审核人员' })
                    }).catch(() => {
                        this.$message({ type: 'error', message: '发送消息通知审核人员失败' })
                    })
                    this.gen_visiable = false
                    this.genData = []
                    this.$refs.procDetailTable.clearSelection()
                    const { href } = this.$router.resolve({
                        path: '/procSend_detail',
                        query: {
                            formCode: res,
                        }
                    })
                    window.open(href, '_blank')
                    this.get_data()
                }).catch(() => { })
            }).catch(() => { })
        },
        search() {
            this.search_obj.currentPage = 1
            this.get_data()
        },
        clickRow(row) {
            let index = this.$refs.procDetailTable.selection.findIndex(item => item.id == row.id)
            if (index == -1) this.$refs.procDetailTable.selection.push(row)
            else this.$refs.procDetailTable.selection.splice(index, 1)
        }

    },
    mounted() {
        this.showTime()
        if (this.$route.query.row) {
            this.headObj = JSON.parse(this.$route.query.row)
            this.search_obj.formCode = this.headObj.formCode
            this.search()
        }
    },
    created() {

    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = ''
        }
    },
}
</script>
<style scoped>
.title {
    font-size: 20px;
    font-family: '黑体';
    font-weight: 700;
    height: 4%;
    display: flex;
    padding-left: 10px;
    align-items: center;
}

.proc_nav {
    display: flex;
    align-items: center;
    padding: 0 15px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
}

.nav_left {
    width: 78%;
}

.nav_right {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    width: 22%;
}

.header-text-left {
    height: 38px;
    line-height: 38px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}

.pe-header-text {
    margin-left: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 45px;
    color: rgba(255, 255, 255, 0.9);
}

.header-right {
    font-size: 13px;
    height: 19px;
    line-height: 25px;
    text-align: right;
    padding-right: 15px;
    color: rgba(255, 255, 255, 0.85);
}

.header-right:first-child {
    font-weight: 500;
}

.table-body {
    /* height: 80%; */
    flex: 1;
    padding: 15px;
}

.table-footer {
    height: 5%;
    display: flex;
    padding-left: 15px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
}

.page_footer {
    height: 2%!important;
    font-size: 13px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dialog-height::v-deep .el-table__body-wrapper {
    max-height: 65vh !important;
    overflow: scroll;
    padding-top: 0px;
}

.dialog-height::v-deep .el-dialog__body {
    padding: 20px !important;
}

/deep/.el-table .sort-caret.ascending {
    border-bottom-color: #fff;
}

/deep/.el-table .ascending .sort-caret.ascending {
    border-bottom-color: #d5d9dd;
}

/deep/.el-table .sort-caret.descending {
    border-top-color: #fff;
}

/deep/.el-table .descending .sort-caret.descending {
    border-top-color: #d5d9dd;
}

.nav_left>>>.el-descriptions-item__cell {
    padding: 8px 5px !important;
    /* line-height: 2.5; */
}

.table-body>>>.el-table .cell {
    padding: 8px 12px;
}

.gen_data {
    height: 780px;
}

/deep/ .el-dialog__body {
    padding: 20px !important;
}

.table-body>>>.el-table-column--selection .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.bg {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.bg >>>.el-table .cell {
    padding: 8px 5px;
}
</style>
<style>

.el-header {
    background-color: #12b4bd;
}

.el-main {
    background-color: #ccc;
}

.el-footer {
    background-color: #12b4bd;
}

.el-table__body tr:hover>td {
    background-color: #c0ddaf !important;
}

/* .table-body .selected-row {
    background-color: #c0ddaf !important;
} */

/* .nav .el-button {
    border-color: #12b4bd;
    color: #12b4bd;
} */

.selected-row>td {
    background-color: #c0ddaf !important;
}

.table-body .el-table .el-checkbox {
    transform: scale(1.5);
}

.el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.185);
    border-radius: 5px;
}

.bg .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
}

.gen_data .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px !important;
    height: 0 !important;
}

.el-input--mini {
    font-size: 14px !important;
}
</style>